module.exports = "#form {\r\n    max-width: 400px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/vehicles/vehicle-form/vehicle-form.component.css
// module id = ./src/app/components/vehicles/vehicle-form/vehicle-form.component.css
// module chunks = main